import React from 'react'
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { RecordActionsTabs } from "components/ui/layouts"
import { Title } from "react-admin"
import { Box } from '@mui/material'
import { AuditTable, FieldConfig } from 'components/audit'


const TabList = () => {
    return (
        <Box display="flex" flexDirection="column" width="100%">
           <RecordActionsTabs resourceParent="objects" />
        </Box>
    )
}

// Пример использования компонента AuditTable на отдельной странице
export const ObjectAuditHistoryPage = () => {
  const { id } = useParams<{ id: string }>()
  const translate = useTranslate()
  const deviceConfigs: FieldConfig[] = [
    { field: 'name', label: translate("resources.objects.fields.name"), visible: true },
    { field: 'address', label: translate("resources.objects.fields.address"), visible: true },
    { field: 'companies[resource]', label: translate("internal.company_resource"), visible: true },
    { field: 'companies[customer]', label: translate("internal.company_customer"), visible: true },
    { field: 'companies[service]', label: translate("internal.company_service"), visible: true },
    { field: 'object_category_id', label: translate("resources.objects.fields.object_category_id"), visible: true },
    { 
      field: 'object_industry_ids', 
      label: translate("resources.objects.fields.object_industry_ids"), 
      visible: true,
      extractNamesFromArray: true
    },
    { 
      field: 'parent_ids', 
      label: translate("resources.objects.fields.parent_ids"), 
      visible: true,
      extractNamesFromArray: true
    },
    { field: 'timezone', label: translate("resources.common.fields.timezone"), visible: true },
    { field: 'geoposition', label: translate("resources.objects.fields.geoposition"), visible: true },
    { field: 'description', label: translate("resources.common.fields.description"), visible: true },
  ]


  return (
     <>
        <Title title={translate('internal.audit')}/>
        <TabList />
        <AuditTable 
          tableName="objects"
          recordId={id!}
          showUserColumn={true}
          dense={false}
          className="audit-history-table"
          fieldConfigs={deviceConfigs}
        />
     </>
  )
}

export default ObjectAuditHistoryPage
